import axios from 'axios';
// import Qs from 'qs'
import router from '../router/router';
import store from "@/store/store";
import Toast from 'muse-ui-toast';
import Vue from "vue";
import { Snackbar } from "muse-ui";
Vue.use(Snackbar)

axios.defaults.baseURL = process.env.VUE_APP_APIURL
axios.defaults.timeout = 60000

axios.interceptors.request.use(
    config => {
        if (!config.headers['Content-Type']) {
            config.headers = {
                "Content-Type": "application/json;charset=utf-8;",
            }
        }

        const token = store.state.token;
        if (token) {
          config.headers.authorization = token;
        }

        return config
    },
    error => {
        // 处理请求错误
        return Promise.reject(error)
    }
)
axios.interceptors.response.use(
    res => {
        // console.log(res.data);
        if(res.data.code == "SUCCESS") {
            // 获取token
            if(res.headers.authorization) {
                store.commit("setToken",res.headers.authorization);
            }

            return res.data
        }else {

            // if(res.data.code == "AUTH_001" || res.data.code == "AUTH_002" || res.data.code == "AUTH_003" || res.data.code == "AUTH_004") {
                // store.commit("setToken",null);

                // Toast.error(res.data.message);

                // if(router.history.current.fullPath != "/my") {
                //     get_auth();
                // }

                // if(router.history.current.path == '/Deta') {
                //
                //     let obj ={};
                //     obj["router"]= router.history.current.path;
                //     obj["id"]= router.history.current.query.id;
                //     obj["fromUserId"]= router.history.current.query.fromUserId;
                //     store.commit("setRouters",obj);
                //     router.push({
                //         path: "/"
                //     })
                //
                // }else {
                //     router.push({
                //         path: "/"
                //     })
                // }

                // console.log(router.history.current);
                //
                // store.commit("setRouters",router.history.current.fullPath);
                //
                // router.push({
                //     path: "/login"
                // })


            // }else
            if(res.data.code == "PRODUCT_019") {
                Toast.error(res.data.message);
                return res.data;
            }else {
                Toast.error(res.data.message);
            }


        }


    },
    error => {
        // console.log(error)
        if (error.code === 'ECONNABORTED') {
            // console.log('连接超时，网络不加')
            router.push({
                path: "/NoNetwork"
            })
        } else if (error.response.status == 401) {
            store.commit("setToken",null);
            if(router.history.current.fullPath != "/my") {
                get_auth();
            }
        }else if(error.response.status == 500) {
            Toast.error(error.response.data.message);
            return false;
        }else if(error.response.status == 400) {
            Toast.error(error.response.data.message);
            return false;
        }
        return Promise.reject(error)
    }
)

export function get(url, params = {}, falg) {
    if(!falg) {
        params["timestamp"]= new Date().getTime();
    }

    return new Promise((resolve, reject) => {
        axios.get(falg ? url  + "/" + params + "?=timestamp" + new Date().getTime() : url, falg ? {} : {
            params: params
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url + "?timestamp=" + new Date().getTime(), data)
            .then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
    })
}

export function put(url, data) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
    })
}

export function del(url, params, falg) {
    return new Promise((resolve, reject) => {
        axios.delete(falg ? url + "/" + params : url, falg ? {} : {
            params: params
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function get_auth() {
    let url;
    url= "https://open.weixin.qq.com/connect/oauth2/authorize?" +
        "appid="+ process.env.VUE_APP_AppID +
        "&redirect_uri=" + process.env.VUE_APP_WxUrl + "/login" +
        "&response_type=code" +
        "&scope=snsapi_userinfo" +
        "&state=STATE#wechat_redirect"
    // window.location.href= this.url;
    window.location.replace(url);
}

export function isIos() {
    let u = navigator.userAgent;
    // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
        window.addEventListener('pageshow', function (e) {
            if(e.persisted || (window.performance && window.performance.navigation.type == 2)){
                window.location.reload()
            }
        });
    }
    // if(isAndroid) {
    //     window.addEventListener('pageshow', function (e) {
    //         if(e.persisted || (window.performance && window.performance.navigation.type == 2)){
    //             window.location.reload()
    //         }
    //     });
    // }

}
